<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <div class="page-block__header">
                    <h1 class="page-block__title | u-font-weight-normal">{{ trans('page.profile.title') }}</h1>
                </div>

                <profile-overview />
            </div>
        </div>
    </div>
</template>

<script>
import { ProfileOverview } from 'relapp-profile';

export default {
    components: {
        ProfileOverview
    },
    metaInfo: {
        title: trans('page.profile.title')
    }
};
</script>
